import { StorefrontModule } from '@vue-storefront/core/lib/modules';
import { configStore } from './store'

export const ConfigModule: StorefrontModule = async function ({ app, store, router, moduleConfig, appConfig }) {
  store.registerModule('storeConfig', configStore)
}
